<template>
  <div class="all-prices__markets">
    <div
      v-show="loading"
      class="w-100 h72 f fc"
    >
      <i class="i-loading" />
    </div>
    <template v-if="!loading">
      <AllPricesButton
        v-for="offer in markets"
        :key="offer?.market?.market_name"
        :class="{
          'btn-primary': activeMarkets?.includes(offer?.market?.market_name || ''),
          'btn-primary-stroke': !activeMarkets?.includes(offer?.market?.market_name || ''),
        }"
        :market="offer?.market"
        :price="offer?.price"
        class="btn"
        @click="handleClick(offer?.market?.market_name || '')"
        @mouseenter="handleMouseEnter(offer?.market?.market_name || '')"
      >
        <!--        <AllPricesButton :market="offer?.market" :price="offer?.price" /> -->
      </AllPricesButton>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { ComparisonPriceInfo, InputMaybe } from '~/graphql/generated/schema-types';
import AllPricesButton from './AllPricesButton.vue';

const props = defineProps<{
  markets: ComparisonPriceInfo[]
  activeMarkets: InputMaybe<string>[]
  way: 'from' | 'to'
  loading: boolean
  chartMarket?: string
}>();

const emit = defineEmits<{
  (e: 'click', marketName: string): void
  (e: 'mouseenter', marketName: string, way: 'from' | 'to'): void
}>();

function handleMouseEnter(marketName: string) {
  emit('mouseenter', marketName, props.way);
}

function handleClick(marketName: string) {
  emit('click', marketName);
}
</script>

<style lang="scss" scoped>
.all-prices__markets {
  display: grid;
  grid-template-columns: repeat(3, minmax(142px, 1fr));
  gap: 8px;

  .btn-primary-stroke {
    border-color: var(--surfaces-outline);
    color: var(--surfaces-on-surface-variable);
  }

  :deep(.price) {
    font-weight: 600;
  }

  @media screen and (max-width: 470px) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
